<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
          <el-form-item label="平台">
            <el-select v-model="formInline.platformId" placeholder="平台" :disabled="platformDisabled" @change="platformChange">
              <el-option v-for="item in platformData"
                         :key="item.platformId"
                         :label="item.platformName"
                         :value="item.platformId">
              </el-option>
            </el-select>
          </el-form-item>

            <el-form-item>
                <el-button-group>
<!--                    <el-button type="primary" size="mini" @click="getList()">查询</el-button>-->
                    <el-button type="success" size="mini" @click="handleAdd()">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
      <el-container style="border: 1px solid #eee">
        <el-aside width="200px" style="overflow:scroll;">
          <el-tree
              style="height: 450px"
              :data="pageLinkOptionList"
              @node-click="handleNodeClick"
              node-key="linkId"
              :highlight-current='true'
              :default-checked-keys="[0]"
              ref="tree"
              :props="defaultProps">
<!--            <template slot-scope="{node, data}">-->
<!--              <el-tooltip  effect="dark" :content="node.label" placement="right">-->
<!--                <span>{{node.label}}</span>-->
<!--              </el-tooltip>-->
<!--            </template>-->

          </el-tree>
        </el-aside>
        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="pageTitle" label="页面名称" width="100"></el-table-column>
            <el-table-column prop="pageUrl" label="页面路径" width="100"></el-table-column>
            <el-table-column prop="templateName" label="模板名称" width="100"></el-table-column>
            <el-table-column prop="templateId" label="模板Id" width="100"></el-table-column>

            <el-table-column prop="event" label="事件" width="100"></el-table-column>
            <el-table-column prop="activeName" label="活动" width="100"></el-table-column>
            <el-table-column prop="orderSource" label="订单来源" width="100"></el-table-column>
            <el-table-column prop="creatTime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="remark" label="备注说明" width="100"></el-table-column>

            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini"
                                   @click="handDelete(scope.row)">删除
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
      </el-container>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
      getPageLinkOption,
      templateSubcriptGetList,
      templateSubcriptGetSingle,
      templateSubcriptSave,
      templateSubcriptDelete,
      getPlatformList2
    } from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: false,
                pageLinkOptionList: [],
                form: {
                    id:null,
                    templateId:null,
                    sence:null,
                    createTime: '',
                    remark: '',
                    platformId:4,
                    pageLinkId:null,
                    pageUrl:'',
                    event:'',
                    bindCode:'',
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    platformId: 4,
                    recordsTotal: 0,
                    pageLinkId:null
                },
                platformDisabled: false,
              defaultProps:{
                label:"pageTitle"
              }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
          this.getPlatfrom();
          this.getPageLinkOptionList();



        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                templateSubcriptGetList(this.formInline).then((res) => {
                    this.loading = false;
                    this.listData = res.data.value;
                })
            },
            getPageLinkOptionList(){
              this.loading = true;
              getPageLinkOption(this.formInline).then((res) => {
                this.loading = false;

                this.pageLinkOptionList = res.data.value;
                if(res.data.value[0]!=undefined) {
                  this.formInline.pageLinkId = res.data.value[0].linkId;
                }else {
                  this.formInline.pageLinkId =null;
                }
                this.getList();
              })
            },
            getPlatfrom(){
              //初始化首页数据
              getPlatformList2().then((res) => {
                this.platformData = res.data;
              });
            },

            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(){
              if(this.formInline.pageLinkId==0||this.formInline.pageLinkId==null){
                this.$message({
                  message: "请选择左侧页面",
                  type: 'error'
                });
              }else {
                this.$router.push({
                  name: 'templateScriptConfigDetail',
                  params: {platformId: this.formInline.platformId, id: 0, pageLinkId: this.formInline.pageLinkId}
                })
              }
            },
            handleEdit(data){
              if(this.formInline.pageLinkId==0||this.formInline.pageLinkId==null){
                this.$message({
                  message: "请选择左侧页面",
                  type: 'error'
                });
              }else {
                this.$router.push({
                  name: 'templateScriptConfigDetail',
                  params: {platformId: this.formInline.platformId, id: data.id, pageLinkId: this.formInline.pageLinkId}
                })
              }
            },
            handDelete(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                  templateSubcriptDelete({Id: row.id}).then((res) => {
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            returnHistory(){
                window.history.back()
            },
          handleNodeClick(data){
            this.formInline.pageLinkId=data.linkId;
            this.getList();
          },
          platformChange(data){
              this.formInline.platformId=data;
              this.getPageLinkOptionList();
              this.getList();
          }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/templateScriptConfigList.vue